import { Injectable } from '@angular/core';

import { ApiApplication } from '@careconne/core/configs/router.config';
import { BulkDaiQRCodeDTO, InsertOrUpdateOneDTO, QRCodeDTO } from '@careconne/core/models/dto/dai-list.dto';

import { ApiService } from '../common/api.service';

@Injectable()
export class DaiListService {
  constructor(private readonly http: ApiService) {}

  getPublicDate() {
    return this.http.post(ApiApplication.DAI_LIST.getPublicDate);
  }

  getListDai() {
    return this.http.get(ApiApplication.DAI_PUBLIC.controller + ApiApplication.DAI_PUBLIC.DAI_LIST);
  }

  insertOrUpdateOne(insertOrUpdateOneDTO: InsertOrUpdateOneDTO) {
    return this.http.post(ApiApplication.DAI_LIST.insertOrUpdateOne, insertOrUpdateOneDTO);
  }

  deleteDaiPublic(daicd: string) {
    return this.http.delete(ApiApplication.DAI_LIST.deleteDaiPublic + daicd);
  }

  createQRCode(qrCodeDTO: QRCodeDTO) {
    return this.http.post(ApiApplication.DAI_QR_CODE.controller, qrCodeDTO);
  }

  bulkCreateQRCode(data: BulkDaiQRCodeDTO) {
    return this.http.post(ApiApplication.DAI_QR_CODE.controller + ApiApplication.DAI_QR_CODE.bulkCreateQRCode, data);
  }

  bulkPublish(publicDate: Date) {
    return this.http.post(ApiApplication.DAI_LIST.bulkPublish, { publicDate });
  }

  bulkUnpublish() {
    return this.http.post(ApiApplication.DAI_LIST.bulkUnpublish);
  }
}
